import { lazy } from "react";

export const CreatorChat = lazy(() => import("./CreatorChat"));

